import React from "react";
import BaseComponent from "../BaseComponent.js";
import { Redirect } from "react-router-dom";
import styled, { css } from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { switchPerformanceColor } from "../Global/tools.js";

import NanoFlex from "../Global/NanoFlex.js";
import Type from "../Global/Typography.js";

import { ReactComponent as PerformanceIndicatorCorner } from "../Global/Icons/PerformanceIndicatorCorner.svg";

const multiple = nota.global.multiple;

const StyledInternationalFlowsTable = styled.div`
  width: 100%;
`;

const StyledLineTable = styled(NanoFlex)`
  height: auto;
  position: relative;
  cursor: ${(props) => (props.selected ? "default" : "pointer")};
  padding: ${multiple / 2 + "px"}; /* 4px */
  display: grid;
  grid-gap: ${multiple / 2 + "px"}; /* 4px */
  grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));
  grid-template-rows: auto;
  grid-auto-flow: dense;
  .colLine {
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .performanceWrapper {
      svg {
        visibility: ${(props) => (props.performanceColorVisible ? "visible" : "hidden")};
        width: 12px;
        path {
          fill: ${(props) => props.performanceColor};
        }
      }
    }
    &:last-child {
      text-align: right;
      grid-column: 6;
    }
  }

  &:nth-child(even) {
    background: ${nota.color.neutral.NeuFour};
  }

  ${({ selected }) =>
    selected &&
    css`
      &:before {
        content: "";
        width: 2px;
        height: 100%;
        background-color: ${nota.color.main.default};
        position: absolute;
        left: -2px;
        top: 0;
      }
      .colLine {
        p {
          font-weight: bold;
        }
      }
    `}

  @media only screen and (max-width: ${nota.global.breakpoints.smallLaptop + "px"}) {
    p {
      font-size: 12px;
    }
  }
`;

class InternationalFlowRow extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.redirect) this.setState({ redirect: false });
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  onProgramClick = () => {
    /*Prevent Click when already open*/
    if (!this.props.selected) this.setState({ redirect: true });
  };

  onProgramMouseDown = (e) => {
    if (e.button == 1) {
      //middle mouse button click
      /*Prevent Click when already open*/
      if (!this.props.selected) window.open(`/card/${this.props.data.idProgram}`, "_blank");
    }
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={`/card/${this.props.data.idProgram}`} />;
    }

    return (
      <StyledLineTable onClick={this.onProgramClick} onMouseDown={this.onProgramMouseDown} performanceColor={switchPerformanceColor(this.props.data.premiereColor)} performanceColorVisible={this.props.data.premiereColor} selected={this.props.selected}>
        <div className="colLine">
          <Type.p>{this.props.data.date}</Type.p>
        </div>
        <div className="colLine">
          <Type.p>{this.props.data.country}</Type.p>
        </div>
        <div className="colLine">
          <Type.p>{this.props.data.channel}</Type.p>
        </div>
        <div className="colLine">
          <Type.p>{this.translation.geral.formatTypes[this.props.data.originalType?.toLowerCase()]}</Type.p>
        </div>
        <div className="colLine">
          <div className="performanceWrapper">
            <PerformanceIndicatorCorner />
          </div>
        </div>
      </StyledLineTable>
    );
  }
}

const InternationalFlowTableRows = (props) => (!props.data ? null : props.data.map((obj, i) => <InternationalFlowRow data={obj} key={obj.idProgram} selected={props.selected === obj.idProgram} />));

const InternationalFlowsTable = (props) => {
  return (
    <StyledInternationalFlowsTable>
      <NanoFlex className="InternationalFlowsTableWrapper" alignItems={"flex-start"} flexDirection={"column"}>
        <InternationalFlowTableRows data={props.data} selected={props.selected} />
      </NanoFlex>
    </StyledInternationalFlowsTable>
  );
};

// Set default props
InternationalFlowsTable.defaultProps = {
  data: [],
};

export default InternationalFlowsTable;

// --- // Documentation // --- //
/*
import InternationalFlowsTable from './../Micro/InternationalFlowsTable.js';

<InternationalFlowsTable />
*/
